import { render, staticRenderFns } from "./centre.vue?vue&type=template&id=522b0ca9&scoped=true&"
import script from "./centre.vue?vue&type=script&lang=js&"
export * from "./centre.vue?vue&type=script&lang=js&"
import style0 from "./centre.vue?vue&type=style&index=0&id=522b0ca9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b0ca9",
  null
  
)

export default component.exports